module.exports = __webpack_public_path__ + "static/img/gibbon-open.96767c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amenities/tables/gibbon-open.jpg
// module id = 633
// module chunks = 0